// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TgWPc","col":"styles_col__FUG6z"};